var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mx-md-n4"},_vm._l((_vm.news),function(item){return _c('div',{key:item.id,staticClass:"col-lg-4 col-sm-6 px-md-4 mb-5"},[_c('news-card',{attrs:{"id":item.id,"heightTitle":250,"image":item.mainImage,"title":item.shortTitle,"views":item.countView,"datePublish":item.datePublic,"text":item.entrySpeech}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }